var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTagUser(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "20px",
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-tag-user") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    transform: "translate(-176.000000, -105.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-tag-user",
    transform: "translate(176.000000, 104.800000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.140992212,
    y: 0.2,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6430304,17.1588817 L16.6430304,17.9716365 L15.0175208,17.9716365 L15.0175208,17.1588817 C15.0175208,14.4656493 12.8342246,12.2823531 10.1409922,12.2823531 C7.44775982,12.2823531 5.26446358,14.4656493 5.26446358,17.1588817 L5.26446358,17.9716365 L3.63895404,17.9716365 L3.63895404,17.1588817 C3.63895404,13.5679052 6.55001569,10.6568435 10.1409922,10.6568435 C13.7319687,10.6568435 16.6430304,13.5679052 16.6430304,17.1588817 Z",
    id: "Path",
    fill: "#777777",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1409922,8.54368111 C11.397834,8.54368111 12.4167056,7.52480953 12.4167056,6.26796775 C12.4167056,5.01112597 11.397834,3.99225439 10.1409922,3.99225439 C8.88415043,3.99225439 7.86527885,5.01112597 7.86527885,6.26796775 C7.86527885,7.52480953 8.88415043,8.54368111 10.1409922,8.54368111 Z M10.1409922,10.1691907 C7.9864063,10.1691907 6.23976931,8.42255367 6.23976931,6.26796775 C6.23976931,4.11338183 7.9864063,2.36674485 10.1409922,2.36674485 C12.2955781,2.36674485 14.0422151,4.11338183 14.0422151,6.26796775 C14.0422151,8.42255367 12.2955781,10.1691907 10.1409922,10.1691907 Z",
    id: "Oval",
    fill: "#777777",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTagUser);
export default __webpack_public_path__ + "static/media/ic-tag-user.23a45d5da05060256e8f9051ba3ccf48.svg";
export { ForwardRef as ReactComponent };